/*
 * @Author: wzh
 * @LastEditTime: 2022-11-24 10:20:51
 * @Description: HTTP
 */
export { strictFetch } from "./strict-fetch";
export { unstrictFetch } from "./unstrict-fetch";
